import { Injectable } from '@angular/core';

// Local token storage service
// used in login.component to persist token after success login

@Injectable()
export class TokenService {

  constructor() {}

  public getToken(): string {
    
    return localStorage.getItem("token");
  }

  public setToken(token: string) {

    localStorage.setItem("token", token);
  }

  public isLoggedIn(): boolean {

    return localStorage.getItem("token") ? true : false;
  }

  public logOut(): boolean {

    localStorage.removeItem("token");
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/token.service.ts